var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('page-header'),_c('router-view',{staticClass:"px-16 py-8"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }